import { Popover } from 'antd'
import WizrButton from '../WizrButton'
import MoreIcon from '../../assets/icons/More'
import EditIcon from '../../assets/icons/EditIcon'
import DeleteIcon from '../../assets/icons/DeleteIcon'
import { useWizrModalContext, MODAL_TYPES } from '../../providers/modal/WizrModalProvider'
import WizrFlexLayout from '../../components/WizrFlexLayout'
import styled from 'styled-components'
import { useState } from 'react'
import { dispatchGetAlertDetails, dispatchUpdateAlert, dispatchGetAlertsForControlRoom, dispatchDeleteAlert, dispatchGetControlRoomDiscoverScreenGetColumns } from '../../redux/actions/content'

interface IAlertActionPopOver {
  detail: any
}

interface IAlertActionPopOverContent {
  onEditAction: () => void
  onDeleteAction: () => void
}

const AlertActionPopOverContent = ({
  onEditAction,
  onDeleteAction
}: IAlertActionPopOverContent): JSX.Element => {
  return (
    <WizrFlexLayout textAlign='left' background='#FFF'>
      <WizrButton
        icon={<EditIcon />}
        text='Edit'
        type='text'
        onClick={onEditAction}
        justifyContent='flex-start'
      />
      <WizrButton
        icon={<DeleteIcon />}
        text='Delete'
        type='text'
        onClick={onDeleteAction}
        justifyContent='flex-start'
      />
    </WizrFlexLayout>
  )
}

const AlertActionPopOver = ({ detail }: IAlertActionPopOver): JSX.Element => {
  const { showModal, hideModal } = useWizrModalContext()
  const [popoverVisible, setPopoverVisible] = useState(false)

  const onEdit = async () => {
    // Close the popover immediately when edit is clicked
    setPopoverVisible(false)
    
    try {
      // First fetch dependent filter values
      await dispatchGetControlRoomDiscoverScreenGetColumns();
      
      // Then fetch detailed alert information
      const alertDetailsPayload = {
        alert_id: detail.id,
        chart_id: detail.chart_id,
        crontab: detail.crontab,
        crontab_humanized: detail.crontab_humanized
      }
      
      console.log('Fetching alert details with payload:', alertDetailsPayload);
      const alertDetailsResponse = await dispatchGetAlertDetails(alertDetailsPayload);
      
      console.log('Alert details fetched:', alertDetailsResponse);
      
      // Open modal with detailed information
      showModal(MODAL_TYPES.CREATE_ALERTS, {
        onFormSubmission: async (updatedData: any) => {
          try {
            console.log('Alert Edit API - Payload with alert_id and chart_id:', updatedData);
            await dispatchUpdateAlert(updatedData);
            // Refresh the alerts list after successful update
            await dispatchGetAlertsForControlRoom({
              limit: 100,
              offset: 0
            });
            hideModal();
          } catch (error) {
            console.error('Failed to update alert:', error);
            // Modal will remain open so user can retry
          }
        },
        action: "edit",
        details: alertDetailsResponse?.data || detail, // Use detailed data if available, fallback to basic data
        onCancel: hideModal,
        alert_id: detail.id,
        chart_id: detail.chart_id,
      })
    } catch (error) {
      console.error('Failed to fetch alert details:', error);
    }
  }

  const onDelete = async () => {
    // Close the popover immediately when delete is clicked
    setPopoverVisible(false)
    
    try {
      const deletePayload = {
        alert_id: detail.id,
        chart_id: detail.chart_id
      };
      
      console.log('Delete Alert - Payload:', deletePayload);
      await dispatchDeleteAlert(deletePayload);
      
      // Refresh the alerts list after successful deletion
      await dispatchGetAlertsForControlRoom({
        limit: 100,
        offset: 0
      });
    } catch (error) {
      console.error('Failed to delete alert:', error);
    }
  }

  return (
    <Popover
      content={<AlertActionPopOverContent onDeleteAction={onDelete} onEditAction={onEdit} />}
      title=''
      trigger='click'
      open={popoverVisible}
      onOpenChange={setPopoverVisible}
    >
      <StyledButton icon={<MoreIcon />} text='' type='text' style={{height: '40px', width: '40px', borderRadius: '50px'}}/>
    </Popover>
  )
}

export default AlertActionPopOver

const StyledButton = styled(WizrButton)`
border-radius: 50%;
width: 20px;
height: 20px;
padding-right: 8px;
justify-content: center;
align-items: center;
  /* Default styles */
  path {
    stroke: #999B9F; /* Default stroke color */
    transition: stroke 0.3s ease; /* Smooth transition for color change */
  }

  /* Hover styles */
  &:hover path {
    stroke: #1D1F22
  }
`;